import { render, staticRenderFns } from "./SubjectChoice.vue?vue&type=template&id=1da8b43b&scoped=true&"
import script from "./SubjectChoice.vue?vue&type=script&lang=js&"
export * from "./SubjectChoice.vue?vue&type=script&lang=js&"
import style0 from "./SubjectChoice.vue?vue&type=style&index=0&id=1da8b43b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da8b43b",
  null
  
)

export default component.exports